// extracted by mini-css-extract-plugin
export default {"container":"ProfileUserNavBar_container__1dTG-","profile-title":"ProfileUserNavBar_profile-title__8HM2K"};